<template>
  <div class="corporation_edit">
    <div
      v-for="headerTitle in headerTitles"
      :key="headerTitle.value"
      class="title_header"
      :style="{backgroundColor: headerTitle.color}"
    >
      <div
        class="title_header_value vertical_align_div"
        @click="pageLink(headerTitle.path)"
      >
        <span class="header_router">
          {{ headerTitle.value }}
        </span>
      </div>
    </div>
    <div class="corporation_maintenance">
      <div class="corporation_maintenance_background">
        <div class="margin_bottom">{{ statusLabel }}{{ status }}</div>
        <div>{{ maintenanceListTitle }}</div>
        <div class="center">
          <table class="content_title" rules="rows">
            <tr class="items_table">
              <td class="table_no">
                <div>{{ noLabel }}</div>
              </td>
              <td class="table_contents">
                <div>{{ startDatetimeLabel }}</div>
              </td>
              <td class="table_contents">
                <div>{{ endDatetimeLabel }}</div>
              </td>
              <td class="table_contents">
                <div>{{ messageLabel }}</div>
              </td>
            </tr>
          </table>

          <div class="table_scroll">
            <table class="items_table" rules="rows">
              <tr
                class="item_table_row"
                v-for="(maintenance, index) in formatDateList"
                :key="maintenance.maintenanceId"
              >
                <td class="table_no">
                  <div>{{ index + 1 }}</div>
                </td>
                <td class="table_contents">
                  <div>{{ maintenance.startDateTime }}</div>
                </td>
                <td class="table_contents">
                  <div>{{ maintenance.endDateTime }}</div>
                </td>
                <td class="table_contents">
                  <div class="message_area">{{ maintenance.message }}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagenation from '../../../pagenation.vue'

export default {
  data() {
    return {
      statusLabel: '状態：',
      maintenanceListTitle: 'メンテナンスリスト',
      noLabel: 'No.',
      startDatetimeLabel: '開始日時',
      endDatetimeLabel: '終了日時',
      messageLabel: '表示メッセージ'
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.setMaintenance(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    headerTitles() {
      return this.$store.state.masters.detailHeaderTitle
    },
    maintenanceList() {
      return this.$store.state.maintenance.maintenanceList
    },
    status() {
      if (this.$store.state.maintenance.status === 0) {
        return '通常稼働'
      } else if (this.$store.state.maintenance.status === 1) {
        return 'メンテナンス中'
      }
    },
    formatDateList() {
      var items = []
      for (let maintenance of this.maintenanceList) {
        var item = Object()
        item.maintenanceId = maintenance.maintenanceId
        item.message = maintenance.message
        var s = new Date(maintenance.startDateTime)
        item.startDateTime =
          s.getFullYear() +
          '/' +
          this.padZero(s.getMonth() + 1) +
          '/' +
          this.padZero(s.getDate()) +
          '  ' +
          this.padZero(s.getHours()) +
          ':' +
          this.padZero(s.getMinutes()) +
          ':' +
          this.padZero(s.getSeconds())
        var e = new Date(maintenance.endDateTime)
        item.endDateTime =
          e.getFullYear() +
          '/' +
          this.padZero(e.getMonth() + 1) +
          '/' +
          this.padZero(e.getDate()) +
          '  ' +
          this.padZero(e.getHours()) +
          ':' +
          this.padZero(e.getMinutes()) +
          ':' +
          this.padZero(e.getSeconds())
        items.push(item)
      }
      return items
    }
  },
  components: {
    pagenation
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    pageLink(path) {
      this.$router.push(path)
    },
    async setMaintenance(pageNo) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('maintenance/setMaintenance', {
          pageNo: pageNo
        })
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode.sysErrorCode_650001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0107')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    },
    padZero(num) {
      return num < 10 ? '0' + num : num
    }
  }
}
</script>

<style scoped>
.table_contents {
  width: 25%;
}
.table_scroll {
  height: 100%;
}
.corporation_maintenance_background {
  height: 790px;
}
.message_area {
  word-break: break-word;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationMaintenance.vue